module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-show-prize"><div class="gifts"></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/show.prize.html
// module id = 25
// module chunks = 0